module.exports = __webpack_public_path__ + "img/historia18.ff74b85d.jpg";